import { createContext } from "react";
import { Contexts } from "../../@types/contexts";
export const Auth = createContext<Contexts.auth>({
    token: null,
    user: null,
    reload: async () => {},
});
